import {
  Tag,
  Icon,
  TagLabel,
  useTheme,
  Text,
  IconName,
} from '@wegroup/design-system';
import { capitalize } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import convertKeyToIconName from '../../../../../../../common/src/utils/convertKeyToIconName';
import { FlowsQuestionGroup } from '../../../../../types/FlowsTypes';
import { getTagContentFromStore } from '../../../common/hooks/useTagContent';

interface Props {
  group: FlowsQuestionGroup;
}

const DuplicateObjectTag: React.FC<React.PropsWithChildren<Props>> = ({
  group,
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation();

  const questionObject = group.duplicateQuestionData?.id.split('.')[0] || '';

  return (
    <Tag colorScheme="cyan" px="3">
      {questionObject && (
        <Icon
          name={
            (group.icon_key as IconName) || convertKeyToIconName(questionObject)
          }
          color={colors.primary[500]}
        />
      )}
      <TagLabel display="flex" ml="2">
        <Text mr="2">
          {getTagContentFromStore(group.tag) ||
            t(
              capitalize(questionObject.replaceAll('_', ' ')) ||
                `FLOWS_TOOLBAR_${group.tag}`,
            )}
        </Text>
        {(group.duplicateQuestionData?.amount || 0) > 1 && (
          <Text>
            {(group.index || 0) + 1}
            {group.duplicateQuestionData?.amount &&
              `/${group.duplicateQuestionData?.amount}`}
          </Text>
        )}
      </TagLabel>
    </Tag>
  );
};

export default DuplicateObjectTag;
